import React from 'react';

import {CircularProgress, IconButton} from '@mui/material';
import {CloudDownload} from '@mui/icons-material';
import ContextElementFunctions from '../../Contexts/ContextElementFunctions';
import {downloadFile, downloadFolder} from './background_tasks';

interface DownloadFileFunctionProps {
  onDownloadStart?: () => void;
}

export const DownloadFileFunction: React.FC<DownloadFileFunctionProps> = ({onDownloadStart}) => {
  const {dir_id, type, name} = React.useContext(ContextElementFunctions);
  const [downloading, setDownloading] = React.useState(false);

  const download = () => {
    if (downloading) return;
    onDownloadStart?.();
    setDownloading(true);
    const onDone = () => setDownloading(false);
    if (type === 'dir') {
      downloadFolder(dir_id, name, onDone);
    } else {
      downloadFile(dir_id, name, onDone);
    }
  };

  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        download();
      }}
      disabled={downloading}
      title={type === 'dir' ? 'Ordner als .zip herunterladen' : 'Datei herunterladen'}>
      {downloading ? <CircularProgress size={24} /> : <CloudDownload />}
    </IconButton>
  );
};
